import { render, staticRenderFns } from "./ModalWhitelistSubmissionConfirmation.vue?vue&type=template&id=38ea1016&"
import script from "./ModalWhitelistSubmissionConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalWhitelistSubmissionConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports